import React from 'react';
import './App.css';
import "bootstrap/dist/js/bootstrap.bundle";
import { Routes, Route } from "react-router-dom";
import Home from './screens/Home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Register from './screens/Register';
import ProtectedRoute from './api/ProtectedRoute';
import SignIn from './components/SignIn';
import ForgetPassword from './components/ForgetPassword';
import ResetPassword from './components/ResetPassword';

function App() {
  return (
    <>
      <Routes>
        <Route
          path="/Sign-up"
          element={
            <ProtectedRoute onlyForLoggedIn={true}>
              <Register />
            </ProtectedRoute>
          }
        />
        <Route path="/Sign-in" element={<SignIn />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
